<script setup lang="ts">
import { EventInfoControl } from '@desktop/views/Relation/Sports/configuration'

import { getComponent, getComponentParams, isEmptyControl } from './utils'

interface Props {
  control: EventInfoControl
}

defineProps<Props>()
</script>

<template>
  <div v-if="isEmptyControl(control)" />
  <component
    :is="getComponent(control)"
    v-else
    v-bind="getComponentParams(control)"
  />
</template>
